import Reveal from "@/components/Reveal";
import { SIMULATOR_URL } from "@/components/Nav";
import { track } from "@/lib/track";

const IMG_LASERS =
  "https://images.unsplash.com/photo-1606814540563-5c02d62fd409?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function SimulatorSection() {
  return (
    <section id="simulator" className="relative py-28 md:py-40" data-testid="simulator-section">
      <div className="container-x">
        <Reveal>
          <div className="clip-frame relative overflow-hidden border border-white/10">
            <img
              src={IMG_LASERS}
              alt="Blue optical light streaming through a dark lab"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-black/75" />
            <div
              className="absolute inset-0"
              style={{
                background:
                  "radial-gradient(55% 60% at 80% 20%, rgba(61,107,255,0.25), transparent 70%)",
              }}
            />
            <div className="relative z-10 grid grid-cols-1 gap-12 p-8 md:grid-cols-12 md:p-16">
              <div className="md:col-span-7">
                <p className="eyebrow mb-6 text-laser">The Simulator</p>
                <h2 className="text-4xl font-semibold tracking-tighter md:text-6xl">
                  The Photonics Classifier
                  <br />
                  lives here.
                </h2>
                <p className="mt-8 max-w-xl text-lg font-light leading-relaxed text-zinc-300">
                  Our web-based simulator finds the compute sweet spot before you commit to
                  hardware: swap between five modulator technologies, choose your laser source
                  and detection mode, inject real non-idealities, and sweep the Pareto pages for
                  accuracy against cost — all in your browser.
                </p>
                <p className="mt-6 font-mono text-xs leading-relaxed text-zinc-500">
                  {"// access is provisioned by a QPI Labs administrator on request"}
                </p>
                <a
                  href={SIMULATOR_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => track("simulator_launch")}
                  data-testid="simulator-open-btn"
                  className="btn-laser mt-10"
                >
                  Open the Simulator
                  <span aria-hidden="true">↗</span>
                </a>
              </div>
              <div className="hidden items-end justify-end md:col-span-5 md:flex">
                <div className="border border-white/10 bg-black/50 p-6 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400 backdrop-blur-md">
                  <div className="text-beam">simulator.qpilabs.com</div>
                  <div className="mt-3 text-zinc-600">photonic inference simulator</div>
                  <div className="mt-3 text-zinc-600">sign-in required</div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <a
            href="/tutorial"
            data-testid="tutorial-teaser-link"
            className="group mt-10 flex items-center justify-between gap-6 border border-white/10 bg-panel p-8 transition-colors hover:border-beam/50 md:p-10"
          >
            <div>
              <p className="eyebrow mb-3">First time in the simulator?</p>
              <p className="text-xl font-light text-zinc-200 md:text-2xl">
                Walk through the core workflow, step by step.
              </p>
            </div>
            <span className="font-mono text-sm text-zinc-500 transition-all duration-300 group-hover:translate-x-2 group-hover:text-beam">
              Read the tutorial →
            </span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
